import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import AdminAuth from './AdminAuth';
import AdminSidebar from './AdminSidebar';
import AdminDashboard from './AdminDashboard'
import AdminUserManagement from './AdminUserManagement'
import AdminSubscriptionManagement from './AdminSubscriptionManagement'
import AdminAnalytics from './AdminAnalytics'
import AdminSettings from './AdminSettings'

const AdminApp = () => {
  return (
    <AdminAuth>
      <div className="flex h-screen bg-gray-50">
        <AdminSidebar />
        
        {/* Main content */}
        <div className="flex-1 md:ml-64">
          <div className="py-6 overflow-y-auto h-full">
            <Routes>
              <Route path="" element={<AdminDashboard />} />
              <Route path="users" element={<AdminUserManagement />} />
              <Route path="subscriptions" element={<AdminSubscriptionManagement />} />
              <Route path="analytics" element={<AdminAnalytics />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="*" element={<Navigate to="/admin" replace />} />
            </Routes>
          </div>
        </div>
      </div>
    </AdminAuth>
  )
}

export default AdminApp